import React, { useCallback, useState } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useChatAlerts } from '../../hooks/useChatAlerts';
import { dashboardChatPath } from '../../lib/dashboardRoutes';

/**
 * Global toast notifier for incoming live chat sessions (Back Office shell).
 */
export default function ChatAlertsNotifier({ userData }) {
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);

  const handleNewSession = useCallback((session) => {
    setToast(session);
  }, []);

  useChatAlerts(userData, { onNewSession: handleNewSession });

  const handleOpen = () => {
    if (!toast?.id) return;
    navigate(dashboardChatPath(toast.id));
    setToast(null);
  };

  const visitorLabel = toast?.visitorName || 'Visitor';

  return (
    <Snackbar
      open={Boolean(toast)}
      autoHideDuration={12000}
      onClose={() => setToast(null)}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        severity="info"
        variant="filled"
        onClose={() => setToast(null)}
        action={(
          <Button color="inherit" size="small" onClick={handleOpen}>
            Open chat
          </Button>
        )}
        sx={{ alignItems: 'center' }}
      >
        New Chat Session from {visitorLabel}
      </Alert>
    </Snackbar>
  );
}
